module.exports = __webpack_public_path__ + "img/FLSH7.2cd7f3fb.svg";